// +----------------------------------------------------------------------
// | 选项卡片：A/B 选项 + 利 / 弊 + 可选中
// +----------------------------------------------------------------------
import { weightToWidth } from '../../lib/format';
import './OptionCard.less';

export default function OptionCard({
  option,
  index = 0,
  selectable = false,
  selected = false,
  onSelect,
  showPercent = false,
  showDetail = true,
}) {
  const pros = option.pros || [];
  const cons = option.cons || [];
  const percent = option.percent;

  const handleClick = () => {
    if (selectable && onSelect) onSelect(option);
  };

  return (
    <div
      className={`option-card ${selectable ? 'is-selectable' : ''} ${selected ? 'is-selected' : ''}`}
      onClick={handleClick}
      role={selectable ? 'button' : undefined}
      tabIndex={selectable ? 0 : undefined}
    >
      <div className="option-card-head">
        <span className="option-card-index">{String.fromCharCode(65 + index)}</span>
        <span className="option-card-name">{option.name}</span>
        {selected && <span className="option-card-check">✓</span>}
      </div>

      {showDetail && option.description && (
        <p className="option-card-desc">{option.description}</p>
      )}

      {showDetail && (pros.length > 0 || cons.length > 0) && (
        <div className="option-card-lists">
          {pros.length > 0 && (
            <ul className="option-card-list is-pros">
              {pros.map((text, i) => (
                <li key={`pro-${i}`}>{text}</li>
              ))}
            </ul>
          )}
          {cons.length > 0 && (
            <ul className="option-card-list is-cons">
              {cons.map((text, i) => (
                <li key={`con-${i}`}>{text}</li>
              ))}
            </ul>
          )}
        </div>
      )}

      {showDetail && option.ai_analysis && (
        <p className="option-card-analysis">{option.ai_analysis}</p>
      )}

      {showPercent && percent !== undefined && percent !== null && (
        <div className="option-card-percent">
          <div className="option-card-percent-bar">
            <span style={{ width: `${weightToWidth(percent)}%` }} />
          </div>
          <span className="option-card-percent-num">{weightToWidth(percent)}%</span>
        </div>
      )}
    </div>
  );
}
